import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Force the payment handling in the SDK.`}</p>
    <Group mdxType="Group">
  <Item title='AUTO' mdxType="Item">
        <p>{`By default, the SDK operates in `}<inlineCode parentName="p">{`PrimerPaymentHandling.AUTO`}</inlineCode>{`
mode. In this case the SDK is responsible for creating the payment.`}</p>
  </Item>
  <Item title='MANUAL' mdxType="Item">
        <p>{`You can use the `}<inlineCode parentName="p">{`PrimerPaymentHandling.MANUAL`}</inlineCode>{` option
in order to `}<a parentName="p" {...{
            "href": "/docs/payments/universal-checkout/advanced-topics/manual-payment-creation/kotlin#step-5-handle-callbacks-for-creating-and-resuming-payments"
          }}>{`handle the payment creation`}</a>{`
by yourself.`}</p>
  </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      